import { createFileRoute } from '@tanstack/react-router'
import { TaxExemptionDetailPage } from '@/features/tax-exemptions/tax-exemption-detail-page'

export const Route = createFileRoute('/_authenticated/tax-exemptions/$formId')({
  staticData: { title: 'Tax exemption' },
  component: TaxExemptionRoute,
})

function TaxExemptionRoute() {
  const { formId } = Route.useParams()
  return <TaxExemptionDetailPage formId={formId} />
}
